// extracted by mini-css-extract-plugin
var _1 = "ChatTableRow-moduleChatTableRow__YGDg9 TableComponent-modulerow__xPAo4";
export { _1 as "ChatTableRow" }
